// @ts-nocheck

import React from 'react';
import styles from '../styles/Banner.module.css';
import { useAtomValue } from 'jotai';

import { languageAtom } from '@shared/store/slice-atoms';
const Banner = ({ bannerConfig }) => {
  const language = useAtomValue(languageAtom);
  const currentBanner = bannerConfig?.[language.locale] || bannerConfig?.['en'];

  if (!currentBanner) return null;

  return (
    <section className={styles['banner-section']}>
      <link rel="preload" fetchpriority="high" as="image" href={currentBanner} type="image/webp" />
      <img src={currentBanner} className="img-fluid banner-img" alt="banner" />
    </section>
  );
};

export { Banner };
